import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApplicationsFormOptions as ApplicationsFormOptions } from './applications-form-options.interface';
import { toFormlyOptions } from './applications-form-helpers';

/**
 * Main configuration builder
 * Combines all sections into expansion panels
 */
export function buildApplicationsFormConfig(options: ApplicationsFormOptions): FormlyFieldConfig[] {
  return [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'keyword',
          type: 'input',
          props: {
            label: 'Search',
            appearance: 'outline',
            change: options.onKeywordChanged,
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'stage',
          type: 'select',
          props: {
            label: 'Stage',
            options: toFormlyOptions(options.stages$),
            appearance: 'outline',
            change: options.onStageChanged,
          },
        },
      ],
    },
  ];
}